import { render } from "./WorkingOnItPopUp.vue?vue&type=template&id=5c6f70d1"
import script from "./WorkingOnItPopUp.vue?vue&type=script&lang=js"
export * from "./WorkingOnItPopUp.vue?vue&type=script&lang=js"

import "./WorkingOnItPopUp.vue?vue&type=style&index=0&id=5c6f70d1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__